import { Navigate } from 'react-router-dom';
import {jwtDecode} from "jwt-decode";

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');

    if (!token) {
        // No token found, user is not authenticated
        return <Navigate to="/" />;
    }

    try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Convert to seconds

        if (decodedToken.exp < currentTime) {
            // Token has expired
            localStorage.removeItem('token'); // Consider clearing the token
            return <Navigate to="/" />;
        }

        // Token is valid and not expired
        return children;
    } catch (error) {
        // Token is invalid or error occurred during decoding
        localStorage.removeItem('token'); // Consider clearing the token
        return <Navigate to="/" />;
    }
};

export default ProtectedRoute;